import { render, staticRenderFns } from "./infoChange.vue?vue&type=template&id=01f2aa32&"
import script from "./infoChange.vue?vue&type=script&lang=js&"
export * from "./infoChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports